module.exports = __webpack_public_path__ + "static/media/TiktokLogo.35e58b03.svg";